function showUp(dom) {
    gsap.from(dom, {
        y: '2rem', opacity: 0, ease: 'none', duration: 0.5,
        scrollTrigger: {
            trigger: dom,
            start: 'top bottom-=20%',
            end: '+=0',
            toggleActions: 'play none none reverse',
        }
    })
}

var wFlag = window.innerWidth > 750

$(() => {
    // showUp('.box1_item span')

    ScrollTrigger.create({
        trigger: '.box1',
        start: 'top top+=5%',
        end: '+=40%',
        scrub:1,
        pin:true,
        animation: gsap.timeline()
            .to({}, { duration:0.2 })
            .to('.box1_img', { filter:wFlag?'brightness(0.1)':'brightness(0.4)' })
            .from('.box1_item', { opacity:0,y:'2rem' })
            .to({}, { duration:0.2 })
    })

    ScrollTrigger.create({
        trigger: '.box2_years',
        start: 'top bottom-=30%',
        end: '+=0%',
        //toggleActions: 'play none none reverse',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 10);
            $('.box2y_item div').toggleClass('box2Show',index>2)
            $('.box2_years span').toggleClass('opacity1',index>2)
        },
        animation: gsap.timeline()
            .from('.box2_years', { borderRadius: 0, duration: 0.5, ease: 'none' })
    })

    showUp('.box2_title')

    ScrollTrigger.create({
        trigger: '.box2_bg',
        start: 'top center',
        end: '+=0%',
        //toggleActions: 'play none none reverse',
        animation: gsap.timeline()
            .from('.box2_bg span', { scale: 0 })
    })



    showUp('.box3_item div:nth-child(1) p')
    showUp('.box3_item div:nth-child(2) p')
    showUp('.box3_item div:nth-child(3) p')

    ScrollTrigger.create({
        trigger: '.box3_btm',
        start: 'top bottom-=30%',
        end: '+=30%',
        scrub: 1,
        animation: gsap.timeline()
            .from('.box3_btm div p', { opacity: 0, y: '2rem', stagger: 0.2 })
    })

    var box4Swiper = new Swiper('.box4Swiper', {
        //autoplay: true,
        allowTouchMove: false
    })

    function getNum(index){
        if(wFlag){
            if(index==0){
                return 0
            }else if(index==1){
                return 320
            }else if(index==2){
                return 640
            }else if(index==3){
                return 960
            }else if(index==4){
                return 1270
            }else if(index==5){
                return 1585
            }else if(index==6){
                return 1900
            }
        }else{
            if(index==0){
                return 0
            }else if(index==1){
                return 166
            }else if(index==2){
                return 340
            }else if(index==3){
                return 513
            }else if(index==4){
                return 681
            }else if(index==5){
                return 844
            }else if(index==6){
                return 1020
            }
        }
    }
    var box3Swiper = new Swiper('.box3Swiper', {
        autoplay: true,
        on:{
            slideChange: function(swiper){
                var index = swiper.realIndex
                $('.box2_num span').css({color:'#ddd'})
                $(`.box2_num span:nth-child(${index+1})`).css({color:'black'})
                $('.box2_line div').css({transform:`translate(${getNum(index)}%)`})
            },
        },
    })

    $('.box2_num span').click(function(){
        var index = $(this).index()
        box3Swiper.slideTo(index,300,false)
        $('.box2_num span').css({color:'#ddd'})
        $(this).css({color:'black'})
        $('.box2_line div').css({transform:`translate(${getNum(index)}%)`})
    })

    new Swiper('.box5Swiper', {
        autoplay: true,
        slidesPerView: wFlag ? 2 : 1,
        loop:true,
        navigation: {
            nextEl: '.box5Swiper-button-next',
            prevEl: '.box5Swiper-button-prev',
        },
    })

    showUp('.box4_title')
    ScrollTrigger.create({
        trigger: '.box4',
        start: wFlag?'top top+=2%':'top top+=8%',
        end: '+=40%',
        scrub: 1,
        animation: gsap.timeline()
            .to('.box4_review div:nth-child(n + 4):nth-child(-n + 9)', { opacity: 0})
            .to('.box4_review div:nth-child(1)', {x:wFlag?'-10rem':0,y:wFlag?'-7.2rem':0,opacity: 0})
            .to('.box4_review div:nth-child(2)', {x:wFlag?'3rem':0,y:wFlag?'-16rem':0,opacity: 0},'<')
            .to('.box4_review div:nth-child(3)', {x:wFlag?'22rem':0,y:wFlag?'-23.5rem':0,opacity: 0},'<')
            .from('.box4_nav', {opacity: 0},'-=80%')
            .from('.box4Swiper', {opacity: 0},'<')
            .from('.box4_text', {opacity: 0},'<')
    })

    ScrollTrigger.create({
        trigger: '.box4',
        start: wFlag?'top top+=2%':'top top+=8%',
        end: '+=60%',
        pin:true
    })

    $('.box4_nav div').click(function () {
        var index = $(this).index()
        $(this).addClass('box4Active').siblings().removeClass('box4Active')
        box4Swiper.slideTo(index, wFlag?300:0)
    })

    function initMarquee($track, options = {}) {
        if (!$track || !$track.length) return;

        const config = {
            speed: options.speed ?? 1,   // 滚动速度
            direction: options.direction ?? 'left', // left / right
            pauseOnHover: options.pauseOnHover ?? false
        };

        // 复制一份内容（只复制一次，防止重复调用）
        if (!$track.data('marquee-inited')) {
            $track.append($track.html());
            $track.data('marquee-inited', true);
        }

        let pos = 0;
        let contentWidth = 0;
        let paused = false;

        const dir = config.direction === 'right' ? 1 : -1;
        const speed = config.speed * dir;

        function calcWidth() {
            contentWidth = $track.width() / 2;
        }

        // 初始计算
        setTimeout(calcWidth);

        // resize 重新计算
        $(window).on('resize', calcWidth);

        // hover 暂停（可选）
        if (config.pauseOnHover) {
            $track.on('mouseenter', () => paused = true);
            $track.on('mouseleave', () => paused = false);
        }

        function loop() {
            if (!paused) {
                pos += speed;

                if (speed < 0 && -pos >= contentWidth) {
                    pos += contentWidth;
                }

                if (speed > 0 && pos >= 0) {
                    pos -= contentWidth;
                }

                $track.css('transform', `translate3d(${pos}px,0,0)`);
            }

            requestAnimationFrame(loop);
        }

        loop();
    }

    if(!wFlag){
        initMarquee($('.box4_flag1'), { speed: 1 });
        initMarquee($('.box4_flag2'), { speed: 1 });
        initMarquee($('.box4_flag3'), { speed: 1 });
    }


})


